import Component from "@glimmer/component"
import type { GroupSummary } from "@shared/models/group"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"

interface Signature {
  Args: {
    groupId: string
  }
  Blocks: {
    default?: [model: FindDoc<"group-summary", GroupSummary>]
  }
}

export default class GroupSummaryProvider extends Component<Signature> {
  @use groupSummary = new FindDoc(() => ["group-summary", this.args.groupId])
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::SummaryProvider": typeof GroupSummaryProvider
  }
}
